import { MenuItem, MenuButton, Box } from '@bechtel/gds';
import { Scalars } from '@bechtel/types';
import styled, { css } from 'styled-components';

interface MenuItemStyledProps {
  isDisabled: Scalars['Boolean'];
}
export const MenuItemStyled = styled(MenuItem)<MenuItemStyledProps>`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    padding-left: ${theme.spacings[500]};
    color: ${theme.colors.grey[1000]};
    white-space: nowrap;
    cursor: pointer;
    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.bechtel.blue[100]};
    }
    ${(props: MenuItemStyledProps) =>
      props.isDisabled &&
      css`
        opacity: 0.5;
        pointer-events: none;
      `}
  `}
`;

export const PopperContainerStyled = styled(Box).attrs({ alignItems: { sm: 'baseline' } })`
  ${({ theme }) => css`
    border-radius: ${theme.spacings[200]};
    position: absolute;
    top: calc(${theme.spacings[550]} + ${theme.spacings[550]});
    right: 0;
    z-index: 2;
  `}
`;

export const MenuButtonStyled = styled(MenuButton)`
  ${({ theme }) => css`
    border-color: ${theme.colors.blue[800]};
    align-items: center;
    justify-content: center;
    &:focus {
      box-shadow: none;
    }
    padding-left: calc(${theme.spacings[300]} + ${theme.spacings[200]});
    padding-right: calc(${theme.spacings[300]} + ${theme.spacings[200]});
  `}
`;
